import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getNameSurname } from "../utils/utilFunction";
import config from "../config";
import userPlaceholder from "../assets/user.png";

// Fisher-Yates shuffle algoritması ile rastgele sıralama
function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

function AuthorSlider({ writers = [] }) {
  const [shuffledWriters, setShuffledWriters] = useState([]);

  useEffect(() => {
    if (writers && writers.length > 0) {
      // Sadece profil resmi olan yazarları filtrele (user.jpg ile bitenleri hariç tut)
      const writersWithImage = writers.filter(writer => 
        writer.profileImageUrl && 
        writer.profileImageUrl.trim() !== '' && 
        writer.id !== "user.jpg" &&
        !writer.profileImageUrl.toLowerCase().endsWith('user.jpg')
      );
      // Yazarları rastgele sırala (her component mount olduğunda farklı sırada)
      setShuffledWriters(shuffleArray(writersWithImage));
    }
  }, [writers]);

  if (!shuffledWriters || shuffledWriters.length === 0) {
    return null;
  }

  // Her slide'da 4 yazar göster (1 satır)
  const itemsPerSlide = 4;
  const slides = [];
  for (let i = 0; i < shuffledWriters.length; i += itemsPerSlide) {
    slides.push(shuffledWriters.slice(i, i + itemsPerSlide));
  }

  return (
    <div className="author-slider-wrapper">
      <div className="d-flex justify-content-between mb-4">
        <h2 className="title _set">Yazarlar</h2>
        <Link className="seeAll" to="/yazarlar">
          Tümü
        </Link>
      </div>
      <Carousel
        indicators={false}
        controls={slides.length > 1}
        interval={null}
        className="author-slider"
      >
        {slides.map((slideWriters, slideIndex) => (
          <Carousel.Item key={slideIndex}>
            <div className="author-slider-grid">
              {slideWriters.map((writer) => {
                const fullName = getNameSurname(writer);
                const authorPath = `/yazar-detay/${writer.id}/${fullName}`;
                const imageUrl = writer.profileImageUrl
                  ? `${config.userAuthApiUrl}${writer.profileImageUrl}`
                  : userPlaceholder;

                return (
                  <Link
                    key={writer.id}
                    to={authorPath}
                    className="author-slider-card"
                  >
                    <div className="author-slider-card__image-wrapper">
                      <img
                        src={imageUrl}
                        alt={fullName}
                        className="author-slider-card__image"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = userPlaceholder;
                        }}
                      />
                    </div>
                    <div className="author-slider-card__name">
                      {fullName}
                    </div>
                    {writer.itemCount > 0 && (
                      <div className="author-slider-card__count">
                        {writer.itemCount} madde
                      </div>
                    )}
                  </Link>
                );
              })}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default AuthorSlider;
